export default __webpack_public_path__ + "static/media/image.bitzify.af6cb78a.png";